import { Box, Typography } from "@mui/material";
import MzInput from "@markaaz/ui/MzInputControls";
import MzDataGrid from "@markaaz/ui/MzDataGrid";
import MzButton from "@markaaz/ui/MzButton";

const sx = {
  datagrid: {
    height: "668px",
    width: "510px",
    "& .MuiDataGrid-cell": {
      padding: "20px"
    },
    "& .MuiDataGrid-columnHeader": {
      padding: "20px"
    }
  },
  input: {
    '& input[type="number"]': {
      "&::-webkit-inner-spin-button, &::-webkit-outer-spin-button": {
        WebkitAppearance: "none",
        margin: 0
      },
      '&[type="number"]': {
        MozAppearance: "textfield"
      },
      "&::-ms-inner-spin-button, &::-ms-outer-spin-button": {
        msAppearance: "none"
      }
    }
  }
};

export default function DataFieldTable({ rows, hasClearAll, onChange, onClear }) {
  const showClearAll = rows.every((row) => !row.fieldOrder);

  const columns = [
    {
      field: "fieldName",
      headerName: "Data Field",
      width: 253,
      sortable: false,
      renderCell: ({ row, value }) => {
        return (
          <Typography variant="body1">
            {value} &nbsp;
            {row.required && (
              <Box component="span" color="negative.c100">
                *
              </Box>
            )}
          </Typography>
        );
      }
    },
    {
      field: "fieldOrder",
      headerName: "Column #",
      width: 120,
      sortable: false,
      renderCell: ({ row, value }) => {
        return (
          <Box className="MuiDataGrid-cellContent">
            <MzInput
              sx={sx.input}
              name="lastName"
              value={value || ""}
              inputProps={{ type: "number" }}
              onWheel={(e) => e.target.blur()}
              onChange={(event) => onChange(row, event.target.value)}
            />
          </Box>
        );
      }
    },
    {
      field: "Clear",
      width: 120,
      sortable: false,
      renderHeader:
        hasClearAll &&
        function () {
          return (
            !showClearAll && (
              <MzButton onClick={onClear} sx={{ paddingLeft: "15px" }}>
                Clear All
              </MzButton>
            )
          );
        },
      renderCell: ({ row }) => {
        return (
          <Box className="MuiDataGrid-cellContent">
            {row.fieldOrder && <MzButton onClick={() => onChange(row, "")}>Clear</MzButton>}
          </Box>
        );
      }
    }
  ];

  return (
    <Box sx={sx.root}>
      <MzDataGrid
        variant="3"
        rowHeight={88}
        autoHeight
        sx={sx.datagrid}
        rows={rows}
        columns={columns}
        disableSelectionOnClick
        disableColumnMenu={true}
        getRowId={(row) => row.fieldName}
        hideFooterPagination
      />
    </Box>
  );
}
